import { ComponentType, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from '@/hooks/redux-helpers';

import { addProfile } from '@/store/actions/profile.actions';

const RequireParam = ({ children }) => {
  const dispatch = useAppDispatch();
  const { userId } = useParams();

  useEffect(() => {
    if (userId?.isNumber()) {
      dispatch(addProfile({ userId: userId.toNumber() }));
    }
  }, [dispatch, userId]);

  return children;
};
export const withProfilePath = (WrappedComponent: ComponentType) => {
  return (
    <RequireParam>
      <WrappedComponent />
    </RequireParam>
  );
};
